<template>
    <div class="fade-in">
        <div class="table-responsive mb-0">
            <table class="table table-sm border mb-0" v-if="languages.length > 0">
                <thead class="thead-light">
                    <tr>
                        <th class="align-middle">Language</th>
                        <th class="align-middle text-center">Write</th>
                        <th class="align-middle text-center">Read</th>
                        <th class="align-middle text-center">Listen</th>
                        <th class="align-middle text-center">Spoken</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in languages"
                        :key="item.uuid || index"
                    >
                        <td class="align-middle font-weight-bold">{{ item.name || '--' }}</td>
                        <td class="align-middle text-center">{{ item.write + '/5' || '--' }}</td>
                        <td class="align-middle text-center">{{ item.read + '/5' || '--' }}</td>
                        <td class="align-middle text-center">{{ item.listen + '/5' || '--' }}</td>
                        <td class="align-middle text-center">{{ item.spoken + '/5' || '--' }}</td>
                    </tr>
                </tbody>
            </table>
            <b-alert
                v-if="!languages || languages.length == 0"
                show
                variant="warning"
                class="text-center"
            >
                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
            </b-alert>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        languages: {
            type: Array,
            required: true,
        },
    },
}
</script>
